import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { newSalesBillingActions } from "../app/newSalesBilling";
import ItemSelectBox2 from "./ItemSelectBox2";
import Swal from "sweetalert2";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "15px",
    borderColor: "#C1CFEF",
    width: "100%",
    //boxShadow: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#C1CFEF" : "white",
    color: "#102048",
    "&:hover": {
      backgroundColor: "#C1CFEF",
    },
  }),
};

const FormPayment = (props) => {
  const {
    subtotal,
    vats,
    taxes,
    grandTotal,
    product,
    currentUser,
    onOrderSubmit,
    discount,
    type,
    customer,
    due,
    selectedValue,
    handleSelectChange,
    deliveryAccountList,
    deliveryFormData,
    setDeliveryFormData,
    invoice,
    status,
    setStatus,
    invoiceData,
    isEdit,
    setIsSave,
    setSaveNoRedirect,
    loader,
    setLoader,
  } = props;

  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  console.log(deliveryFormData);

  const formRef = useRef(null); // Create a ref to the form
  const [showModal, setShowModal] = useState(false);
  const [statusBtn, setStatusBtn] = useState("");
  const [disableClick, setDisableClick] = useState(false);
  const [disablePurchaseClick, setDisablePurchaseClick] = useState(false);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const parcelTypes = [
    { label: "Parcel", value: "parcel" },
    { label: "Document", value: "document" },
    { label: "Fragile Item", value: "fragile" },
    { label: "Liquid Item", value: "liquid" },
    { label: "Electronics", value: "electronics" },
    { label: "Clothing", value: "clothing" },
    { label: "Food Item", value: "food" },
  ];
  const deliveryAreas = [
    { label: "Inside Dhaka", value: "inside dhaka" },
    { label: "Sub Dhaka", value: "sub dhaka" },
    { label: "Outside Dhaka", value: "outside dhaka" },
  ];

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}delivery-method-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setDeliveryMethods(res.data.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // console.log(deliveryMethods);

  const handlePurchaseDisable = () => {
    console.log(
      deliveryFormData?.deliveryName?.toLowerCase() == "hand-to-hand",
      "hand to hand"
    );
    if (deliveryFormData?.deliveryName?.toLowerCase() == "hand-to-hand") {
      setDisablePurchaseClick(true);
    }
  };
  const handleDisable = () => {
    console.log("type................ ",type)
    if (due > 0 && !customer && type !== 'wholesale') {
      Swal.fire({
        icon: "warning",
        title: "Customer Required",
        text: "Please add a customer for due payments.",
      });
      setLoader(false);
      return;
    }
    if (loader) return;
    const isHandToHand =
      deliveryFormData?.deliveryName?.toLowerCase() === "hand-to-hand";

    setDisableClick((prevState) => {
      const newState = isHandToHand ? false : !prevState; // Ensure newState is false for 'hand-to-hand'
      handleSaveSubmit("done", newState); // Pass newDisableClick value
      return newState;
    });
    setStatusBtn("done");
  };
  // hold button handler
  const handleStatus = (statusBtn) => {
    onOrderSubmit();
    // if((deliveryFormData.deliveryName).toLowerCase()!='hand-to-hand' ) {
    //   setShowModal(!showModal)
    // }
    // else{
    //   if(statusBtn=='done'){
    //     onOrderSubmit()
    //   }else{
    //     setStatus(0);
    //     onOrderSubmit()
    //   }
    // }
  };

  const [inputErors, setInputErrors] = useState({
    name: "This field can not be empty!",
    error1: false,
    error2: false,
    error3: false,
    error4: false,
    error5: false,
    errorParcelType: false,
    errorDeliveryArea: false,
  });

  const handleDeliveryInfo = (e) => {
    e.preventDefault();
    setInputErrors({
      ...inputErors,
      error1: deliveryFormData.customerName == "",
      error2: deliveryFormData.customerAddress == "",
      error3: deliveryFormData.customerPhone == "",
      // error4: ( deliveryFormData.deliveryFee==''),
      // error5: ( deliveryFormData.companyName=='' || deliveryFormData.companyName==undefined)
      errorParcelType:
        deliveryFormData?.deliveryName?.toLowerCase() === "steadfast"
          ? deliveryFormData.parcel_type == ""
          : false,
      errorDeliveryArea:
        deliveryFormData?.deliveryName?.toLowerCase() === "steadfast"
          ? deliveryFormData.delivery_area == ""
          : false,
    });
    if (
      deliveryFormData.customerName &&
      deliveryFormData.customerAddress &&
      deliveryFormData.customerPhone &&
      deliveryFormData.deliveryName
    ) {
      if (deliveryFormData?.deliveryName != "hand-to-hand") {
        console.log(
          "FROOOOOOOOOOOOOOOOOOOOOOOOOM ",
          deliveryFormData?.deliveryName
        );
        setShowModal(!showModal);
      }
      if (statusBtn == "done") {
        setStatus(1);
        onOrderSubmit(1);
      } else if (statusBtn == "hold") {
        setStatus(0);
        onOrderSubmit(0);
      }
      setStatusBtn("");
      setselctedDeliveryCompany("");
    }
  };

  const [selectedDeliveryCompany, setselctedDeliveryCompany] = useState(
    deliveryMethods.length
      ? deliveryMethods.find((item) => item.type_name === "hand-to-hand")
      : "Select Delivery Company"
  );
  const [temp, setTemp] = useState({});

  useEffect(() => {
    setTemp(selectedDeliveryCompany);
  }, [selectedDeliveryCompany]);

  useEffect(() => {
    if (deliveryMethods.length) {
      const h = deliveryMethods.find(
        (item) => item.type_name === "hand-to-hand"
      );
      if (h) {
        dispatch(
          newSalesBillingActions.setPosDeliveryFormData({
            ...deliveryFormData,
            deliveryName: h.type_name,
            companyName: h?.delivery_infos.length
              ? h?.delivery_infos[0].company_name
              : null,
            companyId: h?.delivery_infos.length
              ? h?.delivery_infos[0].id
              : null,
          })
        );
      }
    }
  }, [deliveryMethods]);

  useEffect(() => {
    console.log("Status reset:", statusBtn);
  }, [statusBtn]);

  // useEffect(()=>{
  //   setDeliveryFormData({...deliveryFormData,
  //     companyName: temp.label,
  //     companyId: temp.value})

  //   setInputErrors({ ...inputErors, error5: false });
  // },[temp])

  const handleSaveSubmit = (statusBtn, newDisableClick) => {
    console.log(!newDisableClick, "disableCLICK", statusBtn);

    if (!newDisableClick) {
      // setLoader(true);
      if (statusBtn === "done") {
        setStatus(1);
        onOrderSubmit(1);
        dispatch(
          newSalesBillingActions.setPosDeliveryFormData({
            ...deliveryFormData,
            deliveryName: "",
            companyName: "",
            companyId: "",
            customerName: "",
            customerAddress: "",
            customerPhone: "",
            parcel_type: "",
            delivery_area: "",
            note: "",
          })
        );
        console.log("Invoice generated");
      } else if (statusBtn === "hold") {
        setStatus(0);
        onOrderSubmit(0);
        console.log("Hold invoice generated");
      }
    } else {
      setShowModal(true);
    }
  };
  // Child component
  const handleSaveClick = (e) => {
    e.preventDefault();
    if (invoice) {
      return;
    }

    const formData = new FormData(e.target.form);
    const data = Object.fromEntries(formData.entries());
    // console.log("============");
    // console.log(data);
    onOrderSubmit(formData, true); // Pass form data and param
  };
  const handleCancleBtn = () => {
    setselctedDeliveryCompany("");
    setInputErrors({
      ...inputErors,
      error1: false,
      error2: false,
      error3: false,
      error4: false,
      error5: false,
    });
    setShowModal((e) => !e);
  };

  const handleOnSubmit = (e, isSave = 1) => {
    // prevents user from generating invoice more than once
    e.preventDefault();
    if (!disablePurchaseClick) {
      setLoader(true);
      setIsSave(isSave);
      if (isSave !== 1) {
        setStatus(1);
        onOrderSubmit(0);
        dispatch(
          newSalesBillingActions.setPosDeliveryFormData({
            ...deliveryFormData,
            deliveryName: "",
            companyName: "",
            companyId: "",
            customerName: "",
            customerAddress: "",
            customerPhone: "",
            parcel_type: "",
            delivery_area: "",
            note: "",
          })
        );
        setLoader(false);
        return;
      }
      onOrderSubmit(1);
      dispatch(
        newSalesBillingActions.setPosDeliveryFormData({
          ...deliveryFormData,
          deliveryName: "",
          companyName: "",
          companyId: "",
          customerName: "",
          customerAddress: "",
          customerPhone: "",
          parcel_type: "",
          delivery_area: "",
          note: "",
        })
      );
      setLoader(false);
    }
  };

  const handleChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.
    const selectedMethod = deliveryMethods.find((item) => item.id === value);
    setDeliveryFormData({
      ...deliveryFormData,
      deliveryId: value,
      deliveryName: label,
      companyId: selectedMethod.delivery_infos.length
        ? selectedMethod.delivery_infos[0].id
        : null,
    });
    dispatch(
      newSalesBillingActions.setPosDeliveryFormData({
        ...deliveryFormData,
        deliveryId: value,
        deliveryName: label,
        companyId: selectedMethod.delivery_infos.length
          ? selectedMethod.delivery_infos[0].id
          : null,
      })
    );
  };

  const handleChangeParcelType = (name, option) => {
    const { value, label } = option; //some error in this code.
    setDeliveryFormData({
      ...deliveryFormData,
      parcel_type: value,
    });
  };

  const handleChangeDeliveryArea = (name, option) => {
    const { value, label } = option; //some error in this code.
    setDeliveryFormData({
      ...deliveryFormData,
      delivery_area: value,
    });
  };

  console.log("deliveryMethods ", deliveryMethods);
  return (
    // <div>
    //   <div
    //   // ref={formRef}
    //   // className=""
    //   // onSubmit={(e) => {
    //   //   e.preventDefault();
    //   //   onOrderSubmit(e);
    //   // }}
    //   >
    //     {/* <input type="hidden" name="customer_id" value={currentUser.id} /> */}
    //     {/* <input type="hidden" name="pay_mode" value="cash" />
    //     <input type="hidden" name="sub_total" value={subtotal} />
    //     <input type="hidden" name="discount" value={discount} />
    //     <input type="hidden" name="paid_amount" value={grandTotal} /> */}

    //     {type === "billing" || type === "wholesale" ? (
    //       <div className="flex gap-3">

    <div className="min-h-screen flex flex-col ">
      <div
        className="flex-1 pb-20 "
        // ref={formRef}
        // className=""
        // onSubmit={(e) => {
        //   e.preventDefault();
        //   onOrderSubmit(e);
        // }}
      >
        {/* <input type="hidden" name="customer_id" value={currentUser.id} /> */}
        {/* <input type="hidden" name="pay_mode" value="cash" />
        <input type="hidden" name="sub_total" value={subtotal} />
        <input type="hidden" name="discount" value={discount} />
        <input type="hidden" name="paid_amount" value={grandTotal} /> */}

        {type === "billing" || type === "wholesale" ? (
          <div className="flex gap-2 fixed bottom-0 md:right-6 w-[95%] md:w-[39%] p-3 border-t shadow-lg z-10 bg-[#fff] shadow-xs rounded-[15px]  box-border justify-center items-center">
            {/* select option */}
            {/* <div className="flex-none mt-[22px] w-[40%] bg-transparent p-2 grid-cols-1fr font-nunito font-semibold text-lg text-center border border-blue-700 text-[#034AFF] rounded-[16px]">
              <i className="fa-solid fa-file-lines mr-2"></i>
              <select
                id="mySelect"
                className="bg-white focus:outline-none"
                value={selectedValue}
                onChange={handleSelectChange}
              >
                <option className="text-[14px]" value="A4">
                  A4
                </option>
                <option className="text-[14px]" value="3mm">
                  3mm
                </option>
                <option className="text-[14px]" value="2mm">
                  2mm
                </option>
              </select>
            </div> */}
            {/* hold button */}
            <div className="flex-1">
              {/* <Link to={`/invoice/${invoice.invoice_id}`}> */}
              {/* remove type="button" if shows warning */}
              <label
                // type="button"
                // onClick={()=>handleStatus('hold')}
                onClick={() => {
                  handleSaveSubmit("hold"), setStatusBtn("hold");
                }}
                htmlFor="delivery_form"
                // className={` border-[#034AFF] border-[1px]  ${
                //   status === 0
                //     ? "bg-[#034AFF] text-white"
                //     : "bg-white text-[#034AFF]"
                // } p-[6px] w-full font-nunito font-semibold text-lg text-center rounded-[8px]`}

                className={`${
        status === 0
          ? "bg-yellow-500 text-white"
          : "bg-white text-yellow-600 border-yellow-500"
      } border-[1px] px-4 p-2 w-full font-nunito font-semibold text-lg text-center rounded-xl shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer`}
              >
                Hold
              </label>
              {/* </Link> */}
            </div>
            {/* done button */}
            <div className="flex-1">
              {/* <Link to={`/invoice/${invoice.invoice_id}`}> */}
              <label
                type="submit"
                // onClick={()=>handleStatus('done')}
                onClick={() => {
                  if (
                    deliveryFormData.customerName &&
                    deliveryFormData.customerPhone &&
                    deliveryFormData.customerAddress &&
                    deliveryFormData.deliveryName != "hand-to-hand"
                  ) {
                    console.log(
                      "Iseeeeeeeeeeeeeeeeeeeee ",
                      deliveryFormData?.deliveryName
                    );
                    setShowModal(!showModal);
                  } else {
                    setLoader(true);
                    handleDisable();
                  }
                }}
                htmlFor="delivery_form"
                style={{ pointerEvents: loader ? "none" : "auto" }}
                className={` border-[#034AFF] border-[1px] ${
                  statusBtn === "done"
                    ? "bg-[#034AFF] text-white"
                    : "bg-white text-[#034AFF]"
                } p-[6px] w-full font-nunito font-semibold text-lg text-center rounded-[8px]`}
              >
                {/* Print Bill */}
                {/* Done */}
                {console.log("Loader ", loader)}
                {loader ? "Processing..." : "Pay Bill"}
              </label>
              {/* </Link> */}
            </div>
          </div>
        ) : null}
        {type === "purchase" ? (
          <>
            <button
              // type="submit"
              onClick={(e) => {
                handleOnSubmit(e), handlePurchaseDisable();
              }}
              className={`mt-[22px] bg-[#034AFF] p-2 w-full rounded-[8px] font-nunito font-semibold text-lg text-center text-[#FCFCFC]`}
            >
              Print Bill{" "}
            </button>
            <label
              // type="button"
              // onClick={()=>handleStatus('hold')}
              onClick={(e) => {
                handleOnSubmit(e, 0);
              }}
              htmlFor="delivery_form"
              className={`cursor-pointer mt-[22px] border-[#034AFF] border-[1px]  ${
                status === 0
                  ? "bg-[#034AFF] text-white"
                  : "bg-white text-[#034AFF]"
              } p-[6px] w-full font-nunito font-semibold text-lg text-center rounded-[8px]`}
            >
              Hold
            </label>
          </>
        ) : null}
        {!isEdit && type === "booking" ? (
          <div className="flex gap-2">
            <label
              // onClick={(e) => {handleBookingSubmit(0),handleSaveSubmit('hold'),setStatusBtn('hold')}}
              // onClick={(e) => {handleSaveSubmit('hold'),setStatusBtn('hold')}}
              onClick={() => {
                handleSaveSubmit("hold"), setStatusBtn("hold");
              }}
              //type="submit"
              htmlFor="delivery_form"
              className={`border-2 border-solid rounded-[8px] border-[#407BFF] mt-[22px] bg-[#FFFFFF] p-[6px] mr-2.5 w-[30%] font-nunito font-semibold text-lg text-center text-[#034AFF]`}
            >
              save
            </label>

            {invoice ? (
              <Link to={`/advance-bookings/${invoice.invoice_id}`}>
                <label
                  //type="submit" // Change to type="button" to prevent form submission
                  htmlFor="delivery_form"
                  className="mt-[22px] bg-[#034AFF] p-2 w-[50%] rounded-[8px] font-nunito font-semibold text-lg text-center text-[#FCFCFC]"
                >
                  Print Bill{" "}
                </label>
              </Link>
            ) : (
              <label
                // type="submit" // Change to type="button" to prevent form submission
                // onClick={(e) => {handleBookingSubmit(0),setStatusBtn('done'), setDisableClick(true)}}
                // onClick={(e) => { handleSaveSubmit('done'),setStatusBtn('done'), setDisableClick(true)}}
                onClick={() => {
                  handleSaveSubmit("done"), setStatusBtn("done");
                }}
                htmlFor="delivery_form"
                className="mt-[22px] bg-[#034AFF] p-2 w-[50%] rounded-[8px] font-nunito font-semibold text-lg text-center text-[#FCFCFC]"
              >
                Print Bill{" "}
              </label>
            )}
          </div>
        ) : null}
        {isEdit && type === "booking" ? (
          <div className="flex gap-2">
            <button
              onClick={(e) => handleOnSubmit(e, 1)}
              //type="submit"
              className="border-2 border-solid rounded-[8px] p-[6px] border-[#407BFF] mt-[22px] bg-[#FFFFFF] mr-2.5 w-[30%] font-nunito font-semibold text-lg text-center text-[#034AFF]"
            >
              save
            </button>

            <button
              // type="submit" // Change to type="button" to prevent form submission
              onClick={(e) => handleOnSubmit(e, 0)}
              className="flex-grow rounded-[16px] mt-[22px] bg-[#034AFF] p-2 w-[50%] font-nunito font-semibold text-lg text-center text-[#FCFCFC]"
            >
              Confirm Sale{" "}
            </button>
          </div>
        ) : null}
        {/* <button type="submit" className="mt-[22px] bg-[#034AFF] p-2 w-full font-nunito font-semibold text-lg text-center text-[#FCFCFC]">
          Invoice{" "}
        </button> */}
      </div>

      {showModal && (
        <>
          <div>
            <input
              type="checkbox"
              id="delivery_form"
              className="modal-toggle"
            />
            <div className="modal rounded-2xl">
              <div className="modal-box w-[450px] p-0 bg-white">
                <div className="flex justify-between px-[18px] pt-[30px] pb-[25px] border-b border-[#D9D9D9]">
                  <h4 className="font-nunito font-semibold text-lg">
                    Delivery Method
                  </h4>
                  <div className="modal-action">
                    <label
                      htmlFor="delivery_form"
                      className="cursor-pointer modal-action bg-red-600 text-white rounded-lg"
                      onClick={handleCancleBtn}
                    >
                      <GrFormClose />
                    </label>
                  </div>
                </div>
                <div className="px-5 pb-3">
                  <form
                    method="get"
                    className="col-sm-12"
                    data-autosubmit="false"
                    autoComplete="off"
                    onSubmit={handleDeliveryInfo}
                  >
                    <div className={` w-full relative py-3`}>
                      {/* <Select
                        id="mySelect"
                        className="select w-full my-3 text-[#102048] font-normal placeholder:text-[#91919F] bg-transparent outline-none px-[0px]  text-md focus:outline-none"
                        key={selectedDeliveryCompany?.type_name}
                        value={selectedDeliveryCompany?.type_name}
                        onChange={(selectedOption) => {
                          setselctedDeliveryCompany(selectedOption);
                          dispatch(
                            newSalesBillingActions.setPosDeliveryFormData({
                              ...deliveryFormData,
                              deliveryName: selectedOption.value,
                              companyName: selectedOption?.company_name,
                              companyId: selectedOption?.id,
                            })
                          );
                          setInputErrors({ ...inputErors, error5: false });
                        }}
                        options={deliveryMethods.map((item) => ({
                          value: item?.type_name,
                          label: item?.type_name,
                          company_name: item?.delivery_infos.length
                            ? item?.delivery_infos[0].company_name
                            : null,
                          id: item?.delivery_infos.length
                            ? item?.delivery_infos[0].id
                            : null,
                        }))}
                        placeholder={
                          deliveryFormData.type_name ??
                          "Select Delivery Company"
                        }
                        styles={customStyles}
                      /> */}
                      {console.log(
                        "deliveryMethods......... ",
                        deliveryMethods
                      )}
                      {console.log(
                        "deliveryFormData.deliveryName......... ",
                        deliveryFormData.deliveryName
                      )}
                      <ItemSelectBox2
                        name="delivery_id"
                        options={deliveryMethods}
                        value={deliveryFormData.deliveryId}
                        onChange={handleChangeSelect.bind(this, "delivery_id")}
                        label={"Delivery Method"}
                        placeholder={deliveryFormData.deliveryName}
                        style={{
                          maxHeight: "300px",
                          overflowY: "scroll",
                          marginTop: "12px",
                          marginBottom: "12px",
                        }}
                      />
                      {inputErors.error5 ? (
                        <p className="error-message text-red-500 mb-3 pl-1">
                          {inputErors.name}
                        </p>
                      ) : null}
                    </div>
                    <div className="relative border mb-[15px] rounded-2xl flex items-center justify-between w-full bg-white px-3 py-3 border-gray-300 focus-within:border-[#407BFF]">
                      <select
                        className="w-full appearance-none focus:outline-none focus:ring-0"
                        value={deliveryFormData.delivery_type}
                        onChange={(e) =>
                          setDeliveryFormData({
                            ...deliveryFormData,
                            delivery_type: Number(e.target.value), // ensure numeric
                          })
                        }
                      >
                        <option selected value={0}>Home Delivery</option>
                        <option value={1}>Pick Up</option>
                      </select>
                        {/* Custom arrow */}
                        <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 ">
                          ▼
                        </span>
                     </div>
                    <input
                      type="text"
                      name="name"
                      value={deliveryFormData.customerName}
                      onChange={(e) => {
                        const val = e.target.value;
                        setDeliveryFormData({
                          ...deliveryFormData,
                          customerName: val,
                        });
                        dispatch(
                          newSalesBillingActions.setPosDeliveryFormData({
                            ...deliveryFormData,
                            customerName: e.target.value,
                          })
                        );
                        setInputErrors({ ...inputErors, error1: false });
                      }}
                      placeholder="Receiver Name"
                      noOptionsMessage={() => "No options available"}
                      className="input input-bordered w-full mb-[15px] rounded-2xl bg-white"
                    />
                    {inputErors.error1 ? (
                      <p className="error-message text-red-500 mb-3 pl-1">
                        {inputErors.name}
                      </p>
                    ) : null}
                    <input
                      type="text"
                      name="name"
                      value={deliveryFormData.customerAddress}
                      onChange={(e) => {
                        const val = e.target.value;
                        setDeliveryFormData({
                          ...deliveryFormData,
                          customerAddress: val,
                        });
                        dispatch(
                          newSalesBillingActions.setPosDeliveryFormData({
                            ...deliveryFormData,
                            customerAddress: e.target.value,
                          })
                        );
                        setInputErrors({ ...inputErors, error2: false });
                      }}
                      placeholder="Receiver Address"
                      className="input input-bordered w-full mb-[15px] rounded-2xl bg-white"
                    />
                    {inputErors.error2 ? (
                      <p className="error-message text-red-500 mb-3 pl-1">
                        {inputErors.name}
                      </p>
                    ) : null}
                    <input
                      type="number"
                      name="name"
                      value={deliveryFormData.customerPhone}
                      onChange={(e) => {
                        const val = e.target.value;
                        setDeliveryFormData({
                          ...deliveryFormData,
                          customerPhone: val,
                        });
                        dispatch(
                          newSalesBillingActions.setPosDeliveryFormData({
                            ...deliveryFormData,
                            customerPhone: e.target.value,
                          })
                        );
                        setInputErrors({ ...inputErors, error3: false });
                      }}
                      placeholder="Receiver Phone"
                      className="input input-bordered w-full mb-[15px] rounded-2xl bg-white"
                    />
                    {inputErors.error3 ? (
                      <p className="error-message text-red-500 mb-3 pl-1">
                        {inputErors.name}
                      </p>
                    ) : null}
                    {/* <input
                        type='number'
                        name="name"
                        onChange={(e) => {
                          const val = e.target.value;
                          setDeliveryFormData({...deliveryFormData, deliveryFee: val})
                          setInputErrors({ ...inputErors, error4: false });
                        }}
                        placeholder='Delivery Fee'
                        className='input input-bordered w-full mb-[15px] rounded-2xl bg-white'
                      />
                      {inputErors.error4
                      ? <p className="error-message text-red-500 mb-3 pl-1">{inputErors.name}</p>
                      : null} */}
                    {deliveryFormData?.deliveryName?.toLowerCase() ===
                      "steadfast" && (
                      <>
                        {" "}
                        {/* <div className={` w-full relative py-3`}>
                          <ItemSelectBox2
                            name="parcel_type"
                            options={parcelTypes}
                            value={parcelTypes[4].label}
                            onChange={handleChangeParcelType.bind(
                              this,
                              "delivery_id"
                            )}
                            label={"Parcel Type"}
                            placeholder={"Parcel Type"}
                            style={{
                              maxHeight: "300px",
                              overflowY: "scroll",
                              marginTop: "12px",
                              marginBottom: "12px",
                            }}
                          />
                          {inputErors.errorParcelType ? (
                            <p className="error-message text-red-500 mb-3 pl-1">
                              {inputErors.name}
                            </p>
                          ) : null}
                        </div> */}
                        {/* <div className={` w-full relative py-3`}>
                          <ItemSelectBox2
                            name="delivery_area"
                            options={deliveryAreas}
                            value={deliveryAreas[0].label}
                            onChange={handleChangeDeliveryArea.bind(
                              this,
                              "delivery_id"
                            )}
                            label={"Delivery Area"}
                            placeholder={"Delivery Area"}
                            style={{
                              maxHeight: "300px",
                              overflowY: "scroll",
                              marginTop: "12px",
                              marginBottom: "12px",
                            }}
                          />
                          {inputErors.errorDeliveryArea ? (
                            <p className="error-message text-red-500 mb-3 pl-1">
                              {inputErors.name}
                            </p>
                          ) : null}
                        </div> */}
                        <textarea
                          name="note"
                          value={deliveryFormData.note}
                          onChange={(e) => {
                            const val = e.target.value;
                            setDeliveryFormData({
                              ...deliveryFormData,
                              note: val,
                            });
                            dispatch(
                              newSalesBillingActions.setPosDeliveryFormData({
                                ...deliveryFormData,
                                note: e.target.value,
                              })
                            );
                          }}
                          placeholder="Note"
                          className="input input-bordered w-full mb-[15px] rounded-2xl bg-white"
                        />
                      </>
                    )}
                    <div className="button-disabled">
                      <button
                        // onClick={() => setShowModal((prev) => !prev)}
                        onClick={(e) => handleOnSubmit(e, 1)}
                        htmlFor="delivery_form"
                        type="submit"
                        className="cursor-pointer w-full bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

FormPayment.defaultProps = {
  setIsSave: () => {},
  setSaveNoRedirect: () => {},
};

export default FormPayment;
